<div
  style="display: block; position: relative"
  fxLayout="row"
  fxLayoutAlign="center center">
  <div [ngStyle]="{ 'width': width }">
    <canvas
      baseChart
      [data]="chartData"
      [options]="chartOptions"
      (chartClick)="chartClick($event)"
      [plugins]="pieChartPlugins"
      [type]="chartType"></canvas>
  </div>
  <div #legendContainer></div>
</div>
